module.exports = __webpack_public_path__ + "static/img/jiceintroduce.7d79aa2c.jpg";